import { put, select, takeLatest } from 'redux-saga/effects'
import { getPatientTimelineSelector } from '../selectors/patientTimeline.selector'
import { saveTimelineItems, setActivityLog } from '../store/timeline.actions'
import { IItem, ITimelineState } from '../store/timeline.types'
import { TimelineConstants } from '../store/timeline.constants'
import { getIntubationSelector } from '../../intubation/selectors'
import { IIntubationState } from '../../intubation/store/intubation.types'
import { TabConstants } from '../../../components/tabs/Tabs.constants'
import { generateClientCorrelationId } from '../../nemsisData/utils/customElements.util'
import { getProcedureStateSelector } from '../../../components/procedure/selectors'

export function* addIntubationItem() {
  const timeline: ITimelineState = yield select(getPatientTimelineSelector)
  const { items } = timeline
  const { nemsisCodeOptions } = yield select(getProcedureStateSelector)

  const intubationState: IIntubationState = yield select(getIntubationSelector)
  const {
    pta,
    addToTimeline,
    key,
    time,
    date,
    assessedBy,
    size,
    distance,
    attempts,
    successfulAttempt,
    comments,
    isEkgImport,
    method,
    verificationVia,
    rSIProtocol,
    securedVia,
  } = intubationState
  const dateTime = new Date(date || 0)
  if (time) {
    if (time.split(':').length >= 3) dateTime.setSeconds(+time.split(':')[2])
    dateTime.setMinutes(+time.split(':')[1])
    dateTime.setHours(+time.split(':')[0])
  }
  if (addToTimeline) {
    const clientCorrelationId = generateClientCorrelationId(
      nemsisCodeOptions,
      TimelineConstants.INTUBATION_PROCEDURE,
      method?.name || '',
      {
        filter1: verificationVia[0]?.id?.toString(),
        filter2: rSIProtocol?.id?.toString(),
        filter3: securedVia?.id?.toString(),
      },
      key
    )
    const successfulAttemptLabel = successfulAttempt ? 'Yes' : 'No'
    const index = items.findIndex((item) => item.key === key)
    const item: IItem = {
      key: key,
      clientCorrelationId,
      grid: true,
      labelHeaderFlag: pta ? 'PTA' : '',
      labelHeader: time,
      subHeader: date,
      itemType: 'Procedures',
      event: 'Intubation',
      eventSubHeader: `By ${
        assessedBy?.name || ''
      }, Size: ${size}, Distance: ${distance}, Attempts: ${attempts}, Success: ${successfulAttemptLabel}, Comments: ${comments}.`,
      rowActionType: TimelineConstants.SET_INTUBATION_PROCEDURE_ITEM,
      defaultHref: TabConstants.INTUBATION_PROCEDURE,
      date: dateTime,
      ...(isEkgImport && { isEkgImport: isEkgImport }),
    }
    if (index !== -1) {
      items[index] = item
    } else {
      items.push(item)
    }
    yield put(setActivityLog(items))
    yield put(saveTimelineItems())
  }
}

export function* addIntubationItemSaga() {
  yield takeLatest([TimelineConstants.ADD_INTUBATION_ITEM], addIntubationItem)
}
